// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","fundHoldingCardHeader":"_2DlCvK9lpW7l-k6kpDudrV","fundHoldingCardSymbol":"xdvAuGO4yyjJbJRfyBDOV","fundHoldingCardRow":"_3W9zSCi08q-MSVnHxrCHB_"};